<div class="modal-header" cdkDrag cdkDragRootElement=".modal-content" cdkDragHandle>
  <h5 class="modal-title">
    Add Transaction
    <span *ngIf="selectedType.length > 0"> - {{selectedType}}</span>
  </h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body">
  <form [formGroup]="newTransactionDetails" autocomplete="off">

    <!-- Step 1: Type selection -->
    <div class="mb-3" *ngIf="transactionTypeId == 0">
      <label class="form-label fw-semibold">Type</label>
      <div class="d-flex gap-3">
        <div class="form-check">
          <input class="form-check-input" type="radio" formControlName="type" value="1" id="typeIn" (change)="typeChange($event)">
          <label class="form-check-label" for="typeIn">Monies In</label>
        </div>
        <div class="form-check">
          <input class="form-check-input" type="radio" formControlName="type" value="2" id="typeTransfer"
            (change)="typeChange($event)" [attr.disabled]="hasKlyantInvoice() == false ? true : null">
          <label class="form-check-label" for="typeTransfer">Transfer</label>
        </div>
        <div class="form-check">
          <input class="form-check-input" type="radio" formControlName="type" value="3" id="typeOut" (change)="typeChange($event)">
          <label class="form-check-label" for="typeOut">Monies Out</label>
        </div>
      </div>
    </div>

    <!-- Fields shown after type is selected -->
    <ng-container *ngIf="transactionTypeId > 0">

      <!-- Row 1: Invoice (Transfer only) + From Account (Transfer/Monies Out) -->
      <div class="row mb-3">
        <div class="col-sm-6" *ngIf="transactionTypeId == 2">
          <label class="form-label fw-semibold">Invoice</label>
          <select class="form-select" formControlName="invoiceId">
            <option [ngValue]="null"></option>
            <option *ngFor="let inv of invoices" [ngValue]="inv.id">{{inv.invoiceNumber}}</option>
          </select>
        </div>
        <div class="col-sm-6" *ngIf="transactionTypeId == 2 || transactionTypeId == 3">
          <label class="form-label fw-semibold">From Account</label>
          <select class="form-select" formControlName="fromBankAccountId">
            <option [ngValue]="null"></option>
            <option *ngFor="let account of clientAccountList" [ngValue]="account.id">{{account.name}}</option>
          </select>
        </div>
      </div>

      <!-- To Account -->
      <div class="row mb-3" *ngIf="transactionTypeId == 1 || transactionTypeId == 2">
        <div class="col-sm-6">
          <label class="form-label fw-semibold">To Account</label>
          <!-- Monies In - client account -->
          <select *ngIf="transactionTypeId == 1" class="form-select" formControlName="toBankAccountId">
            <option [ngValue]="null">Select Account</option>
            <option *ngFor="let account of clientAccountList" [ngValue]="account.id">{{account.name}}</option>
          </select>
          <!-- Transfer - office account -->
          <select *ngIf="transactionTypeId == 2" class="form-select" formControlName="toBankAccountId">
            <option [ngValue]="null">Select Account</option>
            <option *ngFor="let account of officeAccountList" [ngValue]="account.id">{{account.bank}}</option>
          </select>
        </div>
      </div>

      <!-- Transaction Type (not Transfer) -->
      <div class="row mb-3" *ngIf="transactionTypeId != 2">
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Transaction Type</label>
          <select class="form-select" formControlName="transactionTypeId">
            <option [ngValue]="null"></option>
            <option *ngFor="let type of transactionTypes" [ngValue]="type.transactionTypeId">{{type.type}}</option>
          </select>
        </div>
        <div class="col-sm-6" *ngIf="showOtherTransactionType()">
          <label class="form-label fw-semibold">Transaction Type (Other)</label>
          <input type="text" class="form-control" formControlName="transactionTypeOther">
        </div>
      </div>

      <!-- Cheque/Paying In (not Transfer) -->
      <div class="row mb-3" *ngIf="transactionTypeId != 2 && showChequeDetails()">
        <div class="col-sm-6">
          <label class="form-label fw-semibold">{{transactionTypeId == 1 ? 'Paying in Number' : 'Cheque Number'}}</label>
          <input type="text" class="form-control" formControlName="chequeDetails">
        </div>
      </div>

      <!-- Funds Received (Monies In only) -->
      <div class="row mb-3" *ngIf="transactionTypeId == 1">
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Funds Received From</label>
          <input type="text" class="form-control" formControlName="fundsReceivedFrom">
        </div>
        <div class="col-sm-6" *ngIf="caseTypeId == 8">
          <label class="form-label fw-semibold">Quick Select</label>
          <select class="form-select" (change)="fundsReceivedChange($event)">
            <option value="">-- Quick Select --</option>
            <option value="Search Funds">Search Funds</option>
            <option value="Client Shortfall">Client Shortfall</option>
            <option value="Equity Release Funds">Equity Release Funds</option>
            <option value="Sale Funds">Sale Funds</option>
            <option value="Gift Funds - FROM WHOM">Gift Funds - FROM WHOM</option>
          </select>
        </div>
      </div>

      <div class="row mb-3" *ngIf="transactionTypeId == 1">
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Funds Received Date</label>
          <input type="date" class="form-control" formControlName="fundsReceivedDate">
        </div>
      </div>

      <!-- Value + Payee Name -->
      <div class="row mb-3">
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Value</label>
          <div class="input-group">
            <span class="input-group-text">£</span>
            <input class="form-control" formControlName="value" type="number">
          </div>
        </div>
        <div class="col-sm-6" *ngIf="transactionTypeId == 3">
          <label class="form-label fw-semibold">Payee Name</label>
          <textarea class="form-control" formControlName="payeeName" rows="2"></textarea>
        </div>
      </div>

      <!-- Reference + Description -->
      <div class="row mb-3">
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Reference</label>
          <input class="form-control" formControlName="narrative" placeholder="Klyant Reference">
        </div>
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Description</label>
          <input class="form-control" formControlName="description" placeholder="Klyant Description"
            list="descriptionOptions">
          <datalist id="descriptionOptions">
            <option *ngFor="let opt of descriptionTextOptions" [value]="opt.value">{{opt.text}}</option>
          </datalist>
        </div>
      </div>

      <!-- Method of Verification + Payment Date -->
      <div class="row mb-3">
        <div class="col-sm-6" *ngIf="transactionTypeId == 3">
          <label class="form-label fw-semibold">Method of Verification</label>
          <select class="form-select" formControlName="methodOfVerificationId">
            <option [ngValue]="null">Select Method</option>
            <option *ngFor="let method of methodsOfVerification" [ngValue]="method.methodOfVerificationId">{{method.method}}</option>
          </select>
        </div>
        <div class="col-sm-6" *ngIf="transactionTypeId != 1">
          <label class="form-label fw-semibold">Payment Date</label>
          <input type="date" class="form-control" formControlName="transactionDateTime">
        </div>
      </div>

    </ng-container>

  </form>
</div>

<div class="modal-footer">
  <div *ngIf="hasError" class="text-danger me-auto">{{errorMessage}}</div>

  <button *ngIf="!addingTransactions" type="button" class="btn btn-success"
    [disabled]="newTransactionDetails.invalid"
    (click)="addTransaction()">Add</button>

  <button *ngIf="addingTransactions" type="button" class="btn btn-success" disabled>
    <span class="spinner-border spinner-border-sm" role="status"></span>
    Adding...
  </button>
</div>